import { NotificationType } from './notifications-types';

export const getNotificationTag = (notificationType: NotificationType) => {
	switch (notificationType) {
		case NotificationType.PreITV:
			return `ITV`;
		case NotificationType.Mantenimiento:
			return `Mantenimiento`;
		case NotificationType.BonoPosventa:
			return `Bono Taller`;
		default:
			return '';
	}
};

export const getNotificationMessage = (notificationType: NotificationType, vgedModelGroup?: string, value?: string) => {
	const vehicleName = vgedModelGroup || 'Volkswagen';
	switch (notificationType) {
		case NotificationType.PreITV:
			return `Tu ${vehicleName} tiene una cita: la ITV`;
		case NotificationType.Mantenimiento:
			return `Recuerda que tu ${vehicleName} tiene que pasar por taller `;
		case NotificationType.BonoPosventa:
			return `Te damos la bienvenida con ${value ?? '0€'} para tu próxima visita a taller`;
		default:
			return '';
	}
};
